import { Image } from '@vinted/web-ui'

import { HoVCreatorsSectionCardModel } from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

const HoVCreatorsCard = ({
  title,
  image,
  description,
  index,
}: HoVCreatorsSectionCardModel & { index: number }) => (
  <article className="hov__creators-card" data-testid="hov__creators-card">
    <div className="hov__creators-card-image">
      <Image src={image} scaling={Image.Scaling.Fill} testId={`new-again-card-image-${index}`} />
    </div>
    <h3 className="hov__creators-card-title">{title}</h3>
    <p className="hov__creators-card-description">{description}</p>
  </article>
)

export default HoVCreatorsCard
